import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "CertificacionEjecucionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "CertificacionEjecucionPage",
            ss: ss,
            ajax: {
                "url": ss.indexCertificacionEjecucion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'CertificacionConcat', name: 'Certificacion', title: 'Certificacion', searchable: true },
                { data: 'EjecucionConcat', name: 'Ejecucion', title: 'Ejecucion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            Certificaciones: [],
            Ejecuciones: [],
            CertificacionEjecucion: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        getCertificacion() {
            this.ss.listCertificacion().then(
                (result) => {
                    let response = result.data;
                    this.Certificaciones = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getEjecucion() {
            this.ss.listEjecucion().then(
                (result) => {
                    let response = result.data;
                    this.Ejecuciones = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newCertificacionEjecucion() {
            this.CertificacionEjecucion = {};
            this.$refs['frm-CertificacionEjecucion'].show();
        },
        showCertificacionEjecucion(id) {
            this.isLoading = true;
            this.ss.showCertificacionEjecucion(id).then(
                (result) => {
                    let response = result.data;
                    this.CertificacionEjecucion = response.data;
                    this.$refs['view-CertificacionEjecucion'].show();
                    this.isLoading = false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        editCertificacionEjecucion() {
            this.$refs['frm-CertificacionEjecucion'].show();
            this.$refs['view-CertificacionEjecucion'].hide();
        },
        cancelCertificacionEjecucion() {
            if (this.CertificacionEjecucion.id) {
                this.$refs['view-CertificacionEjecucion'].show();
            }
            this.$refs['frm-CertificacionEjecucion'].hide();
        },
        saveCertificacionEjecucion() {
            this.ss.storeCertificacionEjecucion(this.CertificacionEjecucion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-CertificacionEjecucion'].hide();
                    this.$refs['datatable-CertificacionEjecucion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteCertificacionEjecucion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyCertificacionEjecucion(this.CertificacionEjecucion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-CertificacionEjecucion'].hide();
                                this.$refs['datatable-CertificacionEjecucion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-CertificacionEjecucion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showCertificacionEjecucion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            this.getCertificacion();
            this.getEjecucion();
        }
    }
};
